import React from 'react';

import avatarPlaceholder from '../../avatar-placeholder.png';
import { useUserInfo } from '../../helpers/hooks/useUserInfo';

import { Avatar, IAvatarProps } from './Avatar';

export const CurrentUserAvatar = (props: Omit<IAvatarProps, 'alt' | 'src'>) => {
  const { user } = useUserInfo();

  return (
    <Avatar
      alt={user ? user.nickname : 'Loading...'}
      src={user?.avatar ? user.avatar.url : avatarPlaceholder.src}
      {...props}
    />
  );
};
